import { capProblems, packageCost } from './cost.js';
import { groundFitProblems, heightProblems, readHeights } from './heights.js';
import { measuredProblems, stageProblems } from './stage.js';
import { checkWorldFormat } from './validate.js';
export function codeWorldsOf(worlds) {
    return Object.fromEntries(worlds.map((w) => [w.slug, { name: w.name, features: w.features }]));
}
/** A package of a code world's slug keeps that world's features, so its lessons keep working. */
export function codeWorldProblems(pkg, codeWorlds) {
    const code = Object.hasOwn(codeWorlds, pkg.slug) ? codeWorlds[pkg.slug] : undefined;
    if (!code)
        return [];
    const problems = [];
    const wanted = Object.keys(code.features).sort();
    const have = Object.keys(pkg.features).sort();
    if (wanted.join() !== have.join()) {
        problems.push({
            path: '/features',
            message: `de code-wereld "${pkg.slug}" heeft ${wanted.join(', ') || 'geen onderdelen'}; een pakket met die naam moet het ook hebben`,
        });
        return problems;
    }
    for (const name of wanted) {
        const a = code.features[name];
        const b = pkg.features[name];
        const states = Object.keys(b.states);
        if ([...a.states].sort().join() !== [...states].sort().join()) {
            problems.push({
                path: `/features/${name}/states`,
                message: `de code-wereld "${pkg.slug}" heeft bij ${name} de toestanden ${a.states.join(', ')}; dit pakket ${states.join(', ')}`,
            });
        }
        if (a.initial !== b.initial) {
            problems.push({
                path: `/features/${name}/initial`,
                message: `de code-wereld "${pkg.slug}" begint ${name} met "${a.initial}"`,
            });
        }
        const far = Math.hypot(...a.round.centre.map((v, i) => v - b.round.centre[i]));
        if (far > 0.5 ||
            Math.abs(a.round.radius - b.round.radius) > 0.5 ||
            Math.abs(a.round.height - b.round.height) > 0.5) {
            problems.push({
                path: `/features/${name}/round`,
                message: `moet binnen 0,5 m zijn van de code-wereld: ${JSON.stringify(a.round)}`,
            });
        }
    }
    return problems;
}
/**
 * Every step its input allows (W3): the format; with it valid, the code world, the stage and -- given
 * the height map's bytes -- the height map; given what the worker measured, the measured stage and the
 * budget.
 */
export function checkWorldPackage(input) {
    try {
        return run(input);
    }
    catch {
        // Total: whatever the input, the answer is a list of problems, never a throw.
        return { problems: [{ path: '', message: 'het pakket heeft een vorm die niet te lezen is' }] };
    }
}
function run(input) {
    const format = checkWorldFormat(input.json, input.files);
    const pkg = format.package;
    if (!pkg)
        return { problems: format.problems };
    const problems = [
        ...codeWorldProblems(pkg, input.codeWorlds),
        ...stageProblems(pkg),
        ...capProblems(pkg),
    ];
    if (input.heights) {
        try {
            problems.push(...heightProblems(readHeights(input.heights, pkg.terrain.heights)));
        }
        catch (error) {
            problems.push({ path: '/terrain/heights/file', message: error.message });
        }
    }
    if (!input.measured)
        return problems.length === 0 ? { package: pkg, problems } : { problems };
    problems.push(...measuredProblems(pkg, input.measured));
    // The visible ground against the map models stand on (16 Oct 2026); unmeasured before it.
    if (input.measured.groundFit)
        problems.push(...groundFitProblems(input.measured.groundFit));
    const cost = packageCost(pkg, input.measured);
    problems.push(...cost.problems);
    return problems.length === 0 ? { package: pkg, problems, cost } : { problems, cost };
}
//# sourceMappingURL=check.js.map